import { Component, OnInit, ViewChild, EventEmitter, ChangeDetectionStrategy, Input, AfterViewInit, OnChanges, SimpleChanges, forwardRef, ViewEncapsulation, Output } from "@angular/core";
import { Validators, ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { FieldConfig } from "../../field.interface";
import { NgxSmartModalService } from 'ngx-smart-modal';
import { ControlDisplayMode, DataFor } from '../../../Shared/enum';
import { Observable, of } from 'rxjs';
import { filter, startWith, map, switchMap } from 'rxjs/operators';
import { IData, IQuickSearchable } from '../../../Shared/common';
import { Global } from '../../../Shared/global';
import { CommonDataService } from '../../../Services/commonDataService';

@Component({
  templateUrl: './popup-search.html',
  selector: 'popup-search',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PopupSearchComponent),
      multi: true
    }
  ]
})
export class PopupSearchComponent implements OnInit, AfterViewInit, OnChanges, ControlValueAccessor {
  field: FieldConfig;
  group: FormGroup;

  @ViewChild('modal', /* TODO: add static flag */ {}) modal: NgxSmartModalService;
  @Input() filter = "";
  @ViewChild('dataInput', /* TODO: add static flag */ {}) dataInput: Input;

  //Attributes
  @Input() DisplayMode: ControlDisplayMode = null;
  @Input() dataFor: DataFor = null;
  @Input() EnumDataFor: any = DataFor;
  @Input() required: boolean = false;
  @Input() formControlName: any;
  @Input() selectedData: IQuickSearchable;
  @Input() placeholderText: string = "";
  @Output() itemChanged = new EventEmitter();
  @Input() GetDataAsEntity: boolean = true;
  @Input() dynamicData: boolean = false;
  @Input() isDisabled: boolean = false;

  //
  $allData: Observable<IQuickSearchable[]>;
  $filteredData: Observable<IQuickSearchable[]>;
  filteredOptions: Observable<IQuickSearchable[]>;
  dataForm: FormGroup;
  myControl: FormControl = new FormControl();

  constructor(private fb: FormBuilder, private _service: CommonDataService, public ngxSmartModalService: NgxSmartModalService) {

  }

  ngOnInit() {
    this.dataForm = this.fb.group({
      data: [null, (this.required ? Validators.required : null)]
    });
    this.LoadData();
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  showSearchbox() {
    this.modal.open('modal', false);
  }

  LoadData() {
    this._service
      .getData(Global.BASE_USER_ENDPOINT() + this.createApiEndpoint(this.getApiName(this.dataFor) , Global.getSearchParameters(20, !this.dynamicData, this.filter)))
      .then((x) => {
        this.$allData = of(x.ListItems);
        this.$filteredData = this.data.valueChanges
          .pipe(
            startWith(''),
            switchMap(value => this.filterDataList(value))
          );

      })
      .catch(error => Global.Log(error));
  }

  valuechange(evt) {
    if (this.dynamicData) {
      this.filter = evt.target.value;
      this.LoadData();
    }

  }

  private filterDataList(value: string | IQuickSearchable) {
    let filterValue = '';
    if (value) {
      filterValue = typeof value === 'string' ? value.toLowerCase() : (value.Name != undefined ? value.Name.toLowerCase() : '');
      return this.$allData.pipe(
        map(dt => dt.filter(itm => itm.Name?.toLowerCase().includes(filterValue)))
      );
    } else {
      return this.$allData;
    }
  }

  private displayFn(data?: IQuickSearchable): string | undefined {
    return data ? data.Name : undefined;
  }

  //get createDisplayFn() {
  //  return (data?: IQuickSearchable): string | undefined => {
  //    return data ? data.Name : undefined;
  //  }
  //}

  get data() {
    return this.dataForm.get('data');
  }

  itemSelected($event) {
    if (this.data != undefined && this.data?.value != undefined && this.data?.value != null) {
      if (this.GetDataAsEntity) {
        this.itemChanged.emit(this.data.value);
      }
      else {
        this.itemChanged.emit(this.data);
      }

    }
    else {
      this.data.setValue($event.option.value);
      if (this.GetDataAsEntity) {
        this.itemChanged.emit(this.data.value);
      }
      else {
        this.itemChanged.emit(this.data);
      }
    }

    //if (this.data != undefined && this.data?.value != undefined && this.data?.value != null) {
    //  this.itemChanged.emit(this.data);
    //}
    //else {
    //  this.data.setValue($event.option.value, { emitModelToViewChange: true });
    //  //this.dataForm.get('data').setValue(this.selectedData);

    //  if (this.GetDataAsEntity) {
    //    this.itemChanged.emit($event.option.value);
    //  }
    //  else {
    //    let utForm = new FormControl();
    //    utForm.setValue($event.option.value, { emitModelToViewChange: true });
    //    this.itemChanged.emit(utForm);
    //  }

    //}
  }

  panelClosed($event) {
    if (this.data != undefined && typeof this.data.value === 'string' && this.data.value != "") {
      this.dataForm.get('data').reset();
      this.dataForm.get('data').markAsDirty();
    }



    if (this.GetDataAsEntity) {
      this.propagateChange(this.data.value);
    }
    else {
      this.propagateChange(this.data);
    }

    //if (this.data.value != undefined && this.data.value != null) {
    //  this.propagateChange(this.data);
    //}
  }

  getApiName(listType: DataFor): string {
    let apiPath: string = "";
    switch (listType) {
      case DataFor.Brand:
        apiPath = Global.BrandSearchApi;
        break;
      case DataFor.Category:
        apiPath = Global.CategorySearchApi;
        break;
      case DataFor.Country:
        apiPath = Global.CountrySearchApi;
        break;
      case DataFor.Location:
        apiPath = Global.StorageLocationSearchApi;
        break;
      case DataFor.Product:
        apiPath = Global.ProductSearchApi;
        break;
      case DataFor.Tax:
        apiPath = Global.TaxSearchApi;
        break;
      case DataFor.Customer:
        apiPath = Global.CustomerSearchApi;
        break;
      case DataFor.Distributor:
        apiPath = Global.DistributorSearchApi;
        break;
      //FitnessBox///
      case DataFor.Member:
        apiPath = Global.MemberSearchApi;
        break;
      case DataFor.MembershipPlan:
        apiPath = Global.MembershipPlanSearchApi;
        break;
      case DataFor.UserMembershipPlan:
        apiPath = Global.UserMembershipPlanSearchApi;
        break;
      case DataFor.UserMembershipPlanTemplate:
        apiPath = Global.UserMembershipPlanTemplateSearchApi;
        break;
      case DataFor.BodyPart:
        apiPath = Global.BodyPartSearchApi;
        break;
      case DataFor.MeasurementUnit:
        apiPath = Global.MeasurementUnitSearchApi;
        break;
      case DataFor.Gender:
        apiPath = Global.GenderSearchApi;
        break;
      case DataFor.User:
        apiPath = Global.UserSearchApi;
        break;
      case DataFor.Employee:
        apiPath = Global.StringFormat(Global.EmployeeContractorSearch + "?type={0}", "trainer,staff,dietician");
        break;
      case DataFor.Trainer:
        apiPath = Global.EmployeeContractorSearch;
        break;
      case DataFor.Dietician:
        apiPath = Global.StringFormat(Global.EmployeeContractorSearch+"?type={0}","dietician");
        break;
      case DataFor.UserStage:
        apiPath = Global.StringFormat(Global.GetCommonData, "", "MS");
        break;
      default:
        apiPath = "";
        break;
    }

    return apiPath;
  }

  createApiEndpoint(endpoint: string, searchParam: string) {
    if (endpoint.indexOf("?") > 0) {
      return endpoint + (searchParam.replace("?","&"));
    }
    else {
      return endpoint + searchParam;
    }
  }

  //---------------------------------Control Value Accessor Starts-------------------------------------
  //propagate changes into the custom form control
  propagateChange = (_: any) => { }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value instanceof FormControl) {
      this.selectedData = value.value;
    }
    else {
      this.selectedData = value;
    }
    //this.dataForm.get('data').setValue(this.selectedData, { emitModelToViewChange: true });
    this.dataForm.get('data').setValue(this.selectedData);
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {

  }
  //----------------------------------Control Value Accessor Ends---------------------------------------

}
